export default __webpack_public_path__ + "static/media/V420MANF1.65ba3640.pdf";